import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, ThemedFunctor, TypographyName, FontWeight,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.BIG, SpacingName.SMALL, SpacingName.MEDIUM])}
  background-color: ${theme.palettes.neutrals.lightest};
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.15);
  border-radius: 6px;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    border-radius: 6px 6px 0 0;
    background-color: ${theme.palettes.brand.primary};
  }
`;

export const badge: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, SpacingName.SMALLER])}
  position: absolute;
  top: 0;
  right: 1rem;
  transform: translateY(-50%);
  background-color: ${theme.palettes.brand.secondary};
  color: ${theme.palettes.neutrals.lightest};
  border-radius: 6px;
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H3)}
  color: ${theme.palettes.brand.primary};
  text-align: center;
`;

export const description: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  text-align: center;
`;

export const priceBox: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  display: flex;
  justify-content: center;
`;

export const price: ThemedFunctor = ({
  theme,
  $discountedPrice,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  margin-right: .25rem;
  position: relative;
  line-height: 1 !important;

  ${$discountedPrice && `
    margin-right: 1rem;

    &::after {
      content: '';
      height: 3px;
      position: absolute;
      left: 0;
      right: 0;
      width: 110%;
      background-color: black;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
  `}
`;

export const discountedPrice: ThemedFunctor = ({ theme }) => css`
 ${getTypography(theme, TypographyName.H2)}
  margin-right: .25rem;
`;

export const pricePlaceholder: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  ${getTypography(theme, TypographyName.H2)}
  display: flex;
  justify-content: center;
`;

export const body: ThemedFunctor = () => css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const features: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.MEDIUM)}
  ${getSpacing.paddingTop(theme, SpacingName.MEDIUM)}
  border-top: 2px solid ${theme.palettes.neutrals.light};
  color: ${theme.palettes.neutrals.dark};
`;

export const feature: ThemedFunctor = ({
  theme,
  $highlighted,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  display: flex;
  align-items: flex-start;
  gap: .75rem;

  > *:first-child {
    flex-shrink: 0;
    color: ${$highlighted ? theme.palettes.brand.primary : theme.palettes.neutrals.darkest};
  }

  &:first-child {
    margin-top: 0;
  }
`;

export const notes: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  color: ${theme.palettes.neutrals.medium};

  > * {
    ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  }
`;

export const showMore: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  font-weight: ${FontWeight.BOLD};
  display: flex;
  align-items: center;
  gap: .75rem;

  > *:first-child {
    flex-shrink: 0;
  }
`;

export const action: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, SpacingName.AUTO, 0])}
  max-width: 18rem;
  text-align: center;
  width: 100%;
`;
